import { render, staticRenderFns } from "./PositionWarning.vue?vue&type=template&id=53e4915a&scoped=true"
import script from "./PositionWarning.vue?vue&type=script&lang=js"
export * from "./PositionWarning.vue?vue&type=script&lang=js"
import style0 from "./PositionWarning.vue?vue&type=style&index=0&id=53e4915a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e4915a",
  null
  
)

export default component.exports